import React, { useState, useEffect } from 'react'
import { Grid } from 'antd-mobile'
import { useDispatch, useSelector } from 'react-redux'
import intl from 'react-intl-universal'
import { setProductSpec, selectProductSpec } from '../../store/reducers/cart'
import styles from './index.module.less'
import { formatNumber } from '../../utils/math'
import { getPriceSource, getProductBasePrice, isPackagePriceFree, shouldShowAsFree, shouldShowPackageDiscount } from '../../utils/price'

const SpecsContent = ({ product }) => {
    const [selectedSpec, setSelectedSpec] = useState(null)
    const dispatch = useDispatch()
    const spec = useSelector(selectProductSpec)

    const createProductWithSpec = (spec) => ({
        // ...(spec || product),
        ...spec,
        specItem: spec,
        specsKey: spec?.productExtraNameKey
    })

    const handleSpecChange = (spec) => {
        if (spec.stock > 0 || spec.stock === -1) {            
            const isCurrentlySelected = selectedSpec?.productExtraNameKey === spec.productExtraNameKey
            if(isCurrentlySelected){
                return
            }
            const newSpec = isCurrentlySelected ? null : { ...spec, quantity: 1 }

            setSelectedSpec(newSpec)
            updateCart(newSpec)
        }
    }

    const updateCart = (spec) => {
        const newProduct = createProductWithSpec(spec || selectedSpec)
        dispatch(setProductSpec(newProduct))
    }

    useEffect(() => {
        const specItem = product?.specs[0]
        if (specItem) {
            setSelectedSpec(specItem)
            updateCart(specItem)
        }
        return () => {
            updateCart(null)
        }
    }, [product])

    const renderSpecItem = (spec, index) => {
        const priceSource = getPriceSource({ ...product, specItem: spec })
        return (
        <div key={index} className={styles.specsGridItem}>
            <div
                className={`${styles.specsItem} ${selectedSpec?.productExtraNameKey === spec.productExtraNameKey ? styles.current : ''} ${spec.stock === 0 ? 'disabled' : ''}`}
                onClick={() => handleSpecChange(spec)}
            >
                <div>{spec.productExtraSpecName}</div>
                <div style={{ fontWeight: 500 }}>
                    {isPackagePriceFree(priceSource)
                        ? <>{formatNumber(0)}{product.currency || product.currencyCode}</>
                        : shouldShowAsFree(priceSource)
                            ? intl.get('free').d('免费')
                            : <>{formatNumber(getProductBasePrice(priceSource))}{product.currency || product.currencyCode}</>}
                    {shouldShowPackageDiscount(priceSource) && (
                        <div className={styles.specOriPrice}>
                            {formatNumber(priceSource.price)}{product.currency || product.currencyCode}
                        </div>
                    )}
                </div>
            </div>
        </div>
        )
    }

    if (Object.keys(product).length === 0) {
        return null
    }
    if (product.specs.length === 0) {
        return null
    }

    return (
        <div className={styles.productSpecsWrapper}>
            <div className={styles.specsTitle}>{intl.get('size').d('规格')}</div>
            <div className={styles.specsContentList}>
                <div className={styles.specsGrid}>
                    {product.specs.map(renderSpecItem)}
                </div>
            </div>
        </div>
    )
}

export default SpecsContent
